import { IBatchesCheckbox, ICreateUpdateUserPayload } from 'types';
import { isValid, parseISO } from 'date-fns';

function getStoredDate(value: string | null): Date | null {
  if (!value || value === 'null' || /^\d+$/.test(value.trim())) {
    return null;
  }

  const date = parseISO(value);
  return isValid(date) ? date : null;
}

export function setFilters({
  customization: { selectedOptions, filteredTicketRequest },
}: ICreateUpdateUserPayload) {
  selectedOptions.forEach((value, index) => {
    window.localStorage.setItem(`property${index + 1}`, value.childOption);
    window.localStorage.setItem(`status${index + 1}`, value.headerOption);
  });
  localStorage.setItem(
    'batchesPlants',
    JSON.stringify([
      ...filteredTicketRequest.plants.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInPlants.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'batchesCustomers',
    JSON.stringify([
      ...filteredTicketRequest.customers.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInCustomers.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'batchesMixDesigns',
    JSON.stringify([
      ...filteredTicketRequest.mixDesigns.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInMixDesigns.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'batchesVehicles',
    JSON.stringify([
      ...filteredTicketRequest.vehicles.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInVehicles.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'batchesDrivers',
    JSON.stringify([
      ...filteredTicketRequest.drivers.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInDrivers.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'batchesProjects',
    JSON.stringify([
      ...filteredTicketRequest.projects.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInProjects.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'selectedUsers',
    JSON.stringify([
      ...filteredTicketRequest.users.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInUsers.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'batchesPourEvents',
    JSON.stringify([
      ...filteredTicketRequest.pourEvents.map(i => ({
        additionalId: i.id,
        label: i.name,
        prefix: '+',
        id: i.id,
      })),
      ...filteredTicketRequest.notInPourEvents.map(i => ({
        additionalId: i.id,
        label: i.name,
        prefix: '-',
        id: i.id,
      })),
    ]),
  );

  localStorage.setItem(
    'batchesEventStatusCodes',
    JSON.stringify([
      ...filteredTicketRequest.eventStatusCodes.map(i => ({
        id: i,
        prefix: '+',
        label: i,
      })),
      ...filteredTicketRequest.notInEventStatusCodes.map(i => ({
        id: i,
        prefix: '-',
        label: i,
      })),
    ]),
  );

  localStorage.setItem('batchesFrom', filteredTicketRequest.startDateTime);

  localStorage.setItem('batchesTo', filteredTicketRequest.endDateTime);

  localStorage.setItem(
    'ticketProducts',
    JSON.stringify([
      ...filteredTicketRequest.ticketProducts.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInTicketProducts.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );

  localStorage.setItem(
    'crossShippingGroups',
    JSON.stringify([
      ...filteredTicketRequest.crossShippingGroups.map(i => ({
        ...i,
        label: i.name,
        prefix: '+',
      })),
      ...filteredTicketRequest.notInCrossShippingGroups.map(i => ({
        ...i,
        label: i.name,
        prefix: '-',
      })),
    ]),
  );
}

export function getInitialFilters() {
  const plants = JSON.parse(
    localStorage.getItem('batchesPlants') || '[]',
  ) as IBatchesCheckbox[];
  const customers = JSON.parse(
    localStorage.getItem('batchesCustomers') || '[]',
  ) as IBatchesCheckbox[];
  const mixDesigns = JSON.parse(
    localStorage.getItem('batchesMixDesigns') || '[]',
  ) as IBatchesCheckbox[];
  const vehicles = JSON.parse(
    localStorage.getItem('batchesVehicles') || '[]',
  ) as IBatchesCheckbox[];

  const drivers = JSON.parse(
    localStorage.getItem('batchesDrivers') || '[]',
  ) as IBatchesCheckbox[];
  const projects = JSON.parse(
    localStorage.getItem('batchesProjects') || '[]',
  ) as IBatchesCheckbox[];
  const pourEvents = JSON.parse(
    localStorage.getItem('batchesPourEvents') || '[]',
  ) as IBatchesCheckbox[];
  const eventStatusCodes = JSON.parse(
    localStorage.getItem('batchesEventStatusCodes') || '[]',
  ) as IBatchesCheckbox[];
  const users = JSON.parse(
    localStorage.getItem('selectedUsers') || '[]',
  ) as IBatchesCheckbox[];
  const startDate = getStoredDate(localStorage.getItem('batchesFrom'));
  const endDate = getStoredDate(localStorage.getItem('batchesTo'));

  const ticketProducts = JSON.parse(
    localStorage.getItem('ticketProducts') || '[]',
  ) as IBatchesCheckbox[];

  const crossShippingGroups = JSON.parse(
    localStorage.getItem('crossShippingGroups') || '[]',
  ) as IBatchesCheckbox[];

  return {
    plants,
    customers,
    mixDesigns,
    vehicles,
    drivers,
    projects,
    pourEvents,
    eventStatusCodes,
    users,
    startDate,
    endDate,
    ticketProducts,
    crossShippingGroups,
  };
}

export function getSelectedEntitiesIds({
  customers,
  drivers,
  eventStatusCodes,
  mixDesigns,
  plants,
  pourEvents,
  projects,
  users,
  vehicles,
  ticketProducts,
  crossShippingGroups,
}: Omit<ReturnType<typeof getInitialFilters>, 'startDate' | 'endDate'>) {
  return {
    plants: plants
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    mixDesigns: mixDesigns
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    vehicles: vehicles
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    drivers: drivers
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    customers: customers
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    pourEvents: pourEvents
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.additionalId || '', name: el.label })),
    projects: projects
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    eventStatusCodes: eventStatusCodes
      .filter(el => el.prefix === '+')
      .map(el => el.id),
    users: users
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    ticketProducts: ticketProducts
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    crossShippingGroups: crossShippingGroups
      .filter(el => el.prefix === '+')
      .map(el => ({ id: el.id, name: el.label })),
    notInMixDesigns: mixDesigns
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInPlants: plants
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInVehicles: vehicles
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInDrivers: drivers
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInCustomers: customers
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInPourEvents: pourEvents
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.additionalId || '', name: el.label })),
    notInProjects: projects
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInEventStatusCodes: eventStatusCodes
      .filter(el => el.prefix === '-')
      .map(el => el.id),
    notInUsers: users
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInTicketProducts: ticketProducts
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
    notInCrossShippingGroups: crossShippingGroups
      .filter(el => el.prefix === '-')
      .map(el => ({ id: el.id, name: el.label })),
  };
}
